import { Theme } from "@mui/material";


export const useStyles = (theme: Theme) => {
  // Reusable border declaration for the column-header row.
  const headerBorder = `1px solid ${theme.palette.grey[300]}`;

  return {
    container: {
      width: "100%",
      padding: theme.spacing(1),
      boxSizing: "border-box" as const,
      maxHeight: 390,
      overflowY: "auto" as const,
    },
    headerRow: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      paddingBottom: theme.spacing(1),
    },
    image: {
      width: 56,
      height: 56,
      objectFit: "contain" as const,
      flexShrink: 0,
    },
    imagePlaceholder: {
      width: 56,
      height: 56,
      flexShrink: 0,
    },
    details: {
      display: "flex",
      flexDirection: "column" as const,
      minWidth: 0,
    },
    nameText: {
      whiteSpace: "nowrap" as const,
      overflow: "hidden" as const,
      textOverflow: "ellipsis" as const,
    },
    priceLine: {
      whiteSpace: "nowrap" as const,
      overflow: "hidden" as const,
      textOverflow: "ellipsis" as const,
    },
    loading: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    table: {
      width: "100%",
      borderCollapse: "collapse" as const,
    },
    tableHeaderEmpty: {
      width: 24,
      padding: theme.spacing(0.5, 0),
      borderTop: headerBorder,
      borderBottom: headerBorder,
    },
    tableHeaderLeft: {
      textAlign: "left" as const,
      padding: theme.spacing(0.5, 0),
      borderTop: headerBorder,
      borderBottom: headerBorder,
      textTransform: "uppercase" as const,
    },
    tableHeaderRight: {
      textAlign: "right" as const,
      padding: theme.spacing(0.5, 0),
      borderTop: headerBorder,
      borderBottom: headerBorder,
      textTransform: "uppercase" as const,
    },
    swatchCell: {
      width: 24,
      padding: theme.spacing(0.25, 0.5, 0.25, 0),
    },
    swatchImg: {
      width: 18,
      height: 18,
      objectFit: "cover" as const,
      borderRadius: "2px",
      display: "block",
    },
    valueCell: {
      padding: theme.spacing(0.25, 0),
      whiteSpace: "nowrap" as const,
      overflow: "hidden" as const,
      textOverflow: "ellipsis" as const,
      maxWidth: 120,
    },
    stockCell: {
      padding: theme.spacing(0.25, 0),
      textAlign: "right" as const,
      fontVariantNumeric: "tabular-nums" as const,
    },
  };
};
